import React, { useMemo, useRef } from "react";
// import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Error, Hint, Label } from "@progress/kendo-react-labels";
import JoditEditor from "jodit-react";

// const {
//   Bold,
//   Italic,
//   Underline,
//   AlignLeft,
//   AlignRight,
//   AlignCenter,
//   Indent,
//   Outdent,
//   OrderedList,
//   UnorderedList,
//   Undo,
//   Redo,
//   Link,
//   Unlink,
//   ViewHtml,
//   FontSize,
// } = EditorTools;

const FormRichTextField = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    defaultContent,
    style = { height: "200px" },
    wrapperStyle,
    wrapperClassName,
    minHeight,
    value,
    astrike = false,
    onChange,
  } = fieldRenderProps;

  const showValidationMessage: string | false | null =
    touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const editorRef = useRef<any>(null);

  const config = useMemo<any>(
    () => ({
      beautifyHTML: true,
      beautifyHTMLCDNUrlsJS: [
        "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.0/beautify-html.min.js",
      ],
      readonly: false,
      placeholder: "",
      toolbarButtonSize: "small",
      buttons:
        "bold,italic,underline,strikethrough,eraser,ul,ol,paragraph,image,copyformat,table,link,indent,outdent,left,undo,redo,source,fullsize",
      toolbarAdaptive: false,
      height: style.height,
      width: style.width,
      askBeforePasteHTML: false,
      minHeight: minHeight || 200,
    }),
    []
  );

  // useEffect(() => {
  //   if (editorRef.current) {
  //     const view = editorRef.current.view;
  //     if (view && value) {
  //       // EditorUtils.setHtml(view, value);
  //       // onChange({ value: value });
  //     }
  //   }
  // }, []);

  const handleChange = (newContent: string) => {
    console.log("newContent", newContent);
    // if (editorRef.current) {
    //   const view = editorRef.current.view;
    //   if (view) {
    //     const htmlString = EditorUtils.getHtml(view.state);
    //     onChange({ value: htmlString });
    //   }
    // }
    if (newContent) {
      onChange({ value: newContent });
    }
  };

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
        className="k-form-label"
      >
        {label} {astrike && <span style={{ color: "red" }}>*</span>}
      </Label>
      <div className={"k-form-field-wrap"}>
        {/* <Editor
          className={wrapperClassName}
          ref={editorRef}
          onChange={handleChange}
          onBlur={handleChange}
          tools={[
            FontSize,
            [ViewHtml, Link, Unlink],
            [Bold, Italic, Underline],
            [Undo, Redo],
            [AlignLeft, AlignCenter, AlignRight],
            [OrderedList, UnorderedList, Indent, Outdent],
          ]}
          contentStyle={style}
          defaultContent={defaultContent}
          ariaLabelledBy={labelId}
          ariaDescribedBy={`${hintId} ${errorId}`}
        /> */}

        <JoditEditor
          ref={editorRef}
          className={wrapperClassName}
          // onChange={handleChange}
          onBlur={handleChange}
          config={config}
          value={value ?? defaultContent}
        />

        {showHint && <Hint id={hintId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )}
      </div>
      <style>
        {`
          .jodit-status-bar,
          .jodit-status-bar__item {
            display: none !important;
          }
          .jodit-toolbar__box {
            justify-content: flex-start !important;
          }
          .jodit, .jodit *, .jodit-container, .jodit-container * {
            margin:0;
          }
          .jodit-add-new-line{
          display: none !important;
          }
        `}
      </style>
    </FieldWrapper>
  );
};

export default FormRichTextField;
